import { Navigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { useUserCheck } from '../../hooks/api/useUserCheck'

export const RoleBasedRedirect = () => {
  const { user, loading } = useAuth()
  const { data: userRecord, isLoading } = useUserCheck(user?.id || '')
  const [searchParams] = useSearchParams()
  const plan = searchParams.get('plan')

  if (loading || isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-3 border-gray-400 border-t-transparent border-r-transparent mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace />
  }

  if (userRecord?.role === 'admin') {
    return <Navigate to="/admin/dashboard" replace />
  }

  if (userRecord?.role === 'billing') {
    return <Navigate to="/billing/dashboard" replace />
  }

  if (!userRecord?.company_id) {
    // Preserve plan parameter when redirecting to subscription
    const subscriptionUrl = plan ? `/subscription?plan=${plan}` : '/subscription'
    return <Navigate to={subscriptionUrl} replace />
  }

  if (userRecord?.role === 'employee') {
    return <Navigate to="/issues" replace />
  }

  return <Navigate to="/dashboard" replace />
}
